export default __webpack_public_path__ + "static/media/tree_icon_type_lightBorder_gray_2.34ac120b.svg";